import { Injectable } from '@angular/core'

@Injectable({
  providedIn: 'root',
})
export class CompanyService {
  private selectedCompany: CompanyInfo | undefined = undefined
  constructor() {}
  set SelectedCompany(selectedCompany: any | undefined) {
    this.selectedCompany = selectedCompany
  }
  get SelectedCompany() {
    return this.selectedCompany
  }
}
export interface CompanyInfo {
  corporateNumber: string
  name?: string
  organizationTypeCd?: string
  organizationCd: string
  organizationName: string
  organizationFormalName: string
  organizationNameKana: string
  organizationCategoryCd: string
  organizationCategoryName: string
  displayPositionCd: string
  displayPositionName: string
  postCode: string
  prefecture: string
  city: string
  block: string
  building: string
  telephoneNumber: number
  invoiceNumber?: string
}
